// Google Adsense -------------------------------------------------------------

import {BROWSER_SMALL_SCREEN, browserGetBrowserWidth, browserGetCookie, browserSetCookie} from "./browser.js";
import {consentRequest} from "./consent.js";

const ADSENSE_MAXIMUM_WIDTH = 320;
const ADSENSE_CLIENT = "ca-pub-9941509058397179";
const ADSENSE_ENABLED = true;
const ADSENSE_DEFERRED_ROOT_MARGIN = "800px 0px";
const ADSENSE_REQUEST_SETTLE_TIMEOUT_MS = 2000;
const HOUSE_ADS = [
    {name: "cartells", href: "https://yuppiya.com/#publica", alt: "Cartells Ad"},
    {name: "festa_major", href: "https://yuppiya.com/#publica", alt: "Cartells Ad"},
    {name: "sky", href: "https://yuppiya.com/#publica", alt: "Cartells Ad"},
    {name: "widget", href: "https://yuppiya.com/#widget", alt: "Widget de Cartells"},
    {name: "ioga", href: "https://yuppiya.com/#publica", alt: "Cartells Ad"}
];
const HOUSE_AD_COOKIE_PREFIX = "house-ad-index-";
const HOUSE_AD_COOKIE_DAYS = 365;
const SPACE_AD = {
    href: "https://yuppiya.com/#publicitat",
    alt: {
        ca: "Crea el teu espai a YuppiYa",
        es: "Crea tu espacio en YuppiYa"
    }
};
const ESPAVILAT_POSITION_COOKIE = "espavilat-position";
const ESPAVILAT_MAXIMUM_CAMPAIGNS = 4;
const ESPAVILAT_AD = {
    href: "https://yuppiya.com/#publicitat",
    alt: "L'Espavilat: anuncia't a totes les pàgines de Cartells"
};
let espavilatDynamicAdNumber = 0;
let espavilatDynamicPosition = null;

function houseAdReadIndex(format)
{
    const index = Number.parseInt(browserGetCookie(HOUSE_AD_COOKIE_PREFIX + format), 10);
    return Number.isInteger(index) && index >= 0 ? index % HOUSE_ADS.length : 0;
}

const houseAdIndexes = {
    H: houseAdReadIndex("H"),
    V: houseAdReadIndex("V")
};
let adsenseLoadPromise;
const adsenseRequestQueue = [];
let adsenseRequestInProgress = false;

function houseAdNext(format)
{
    const ad = HOUSE_ADS[houseAdIndexes[format]];
    houseAdIndexes[format] = (houseAdIndexes[format] + 1) % HOUSE_ADS.length;
    browserSetCookie(
            HOUSE_AD_COOKIE_PREFIX + format,
            houseAdIndexes[format],
            HOUSE_AD_COOKIE_DAYS
            );
    return ad;
}

function houseAdFullFormat()
{
    return browserGetBrowserWidth() < BROWSER_SMALL_SCREEN ? "S" : "H";
}

function espavilatIsVisible()
{
    return Array.from(document.querySelectorAll(".espavilatAdLink")).some((ad) =>
    {
        const rect = ad.getBoundingClientRect();
        return ad.getClientRects().length > 0 && rect.width > 0;
    });
}

function espavilatGetActiveCampaigns()
{
    // Encapsulated until the campaign service/API is available.
    return [];
}

function espavilatCanRenderDefault()
{
    return espavilatGetActiveCampaigns().length < ESPAVILAT_MAXIMUM_CAMPAIGNS;
}

function espavilatNextPosition(count)
{
    const value = Number.parseInt(browserGetCookie(ESPAVILAT_POSITION_COOKIE), 10);
    const current = Number.isInteger(value) && value >= 0 ? value : 0;
    browserSetCookie(
            ESPAVILAT_POSITION_COOKIE,
            (current + 1) % 100000,
            HOUSE_AD_COOKIE_DAYS
            );
    return current % Math.max(1, count);
}

function espavilatIsCurrentDynamicPosition()
{
    if (espavilatDynamicPosition === null)
    {
        espavilatDynamicPosition = espavilatNextPosition(ESPAVILAT_MAXIMUM_CAMPAIGNS);
    }
    const current = espavilatDynamicAdNumber;
    espavilatDynamicAdNumber++;
    return current === espavilatDynamicPosition;
}

function espavilatRender(parent, format, responsiveListing = false)
{
    const imageFormat = responsiveListing ? "S" : (format === "H" ? "H" : "S");
    const link = document.createElement("a");
    const picture = responsiveListing ? document.createElement("picture") : null;
    const image = document.createElement("img");
    link.className = "houseAdLink houseAd" + imageFormat + " espavilatAdLink";
    link.href = ESPAVILAT_AD.href;
    link.setAttribute("aria-label", ESPAVILAT_AD.alt);
    image.className = "houseAdImage";
    if (picture !== null)
    {
        const source = document.createElement("source");
        source.media = "(min-width: " + BROWSER_SMALL_SCREEN + "px)";
        source.srcset = "/ads-lespavilat/lespavilat-list-v2.webp";
        picture.appendChild(source);
    }
    image.src = responsiveListing
            ? "/ads-lespavilat/lespavilat-square-v1.webp"
            : imageFormat === "H"
            ? "/ads-lespavilat/lespavilat-v1.webp"
            : "/ads-lespavilat/lespavilat-square-v1.webp";
    image.alt = ESPAVILAT_AD.alt;
    image.loading = "lazy";
    image.decoding = "async";
    if (picture !== null)
    {
        picture.appendChild(image);
        link.appendChild(picture);
    } else
    {
        link.appendChild(image);
    }
    parent.replaceChildren(link);
}

function espavilatAdd(parent, width = 0)
{
    if (width !== 0)
    {
        const wrapper = document.createElement("div");
        wrapper.setAttribute("class", "adWrapper mainItem espavilatListingAd");
        wrapper.style.width = width + "px";
        wrapper.style.textAlign = "center";
        parent.appendChild(wrapper);
        espavilatRender(wrapper, "S", true);
        return;
    }
    espavilatRender(parent, "S", true);
}

function espavilatAddResponsiveRow(parent)
{
    espavilatRender(parent, houseAdFullFormat(), false);
}

function houseAdRender(parent, format)
{
    const rotationFormat = format === "S" ? "H" : format;
    const ad = houseAdNext(rotationFormat);
    const link = document.createElement("a");
    const image = document.createElement("img");
    link.className = "houseAdLink houseAd" + format;
    link.href = ad.href;
    link.setAttribute("aria-label", ad.alt);
    image.className = "houseAdImage";
    image.src = "/ads/" + format + "/" + ad.name + ".jpg";
    image.alt = ad.alt;
    image.loading = "lazy";
    image.decoding = "async";
    link.appendChild(image);
    parent.replaceChildren(link);
}

function spaceAdRender(parent, format)
{
    const language = document.documentElement.lang === "es" ? "es" : "ca";
    const alt = SPACE_AD.alt[language];
    const link = document.createElement("a");
    const image = document.createElement("img");
    link.className = "houseAdLink houseAd" + format;
    link.href = SPACE_AD.href;
    link.setAttribute("aria-label", alt);
    image.className = "houseAdImage";
    const imageFolder = format === "H" ? "W" : "S";
    image.src = "/ads.elteuespai/" + imageFolder + "/elteuespai-v1.webp";
    image.alt = alt;
    image.loading = "lazy";
    image.decoding = "async";
    link.appendChild(image);
    parent.replaceChildren(link);
}

function adsenseLoad()
{
    if (adsenseLoadPromise) return adsenseLoadPromise;

    adsenseLoadPromise = new Promise((resolve, reject) =>
    {
        const script = document.createElement("script");
        script.async = true;
        script.crossOrigin = "anonymous";
        script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client="
                + ADSENSE_CLIENT;
        script.addEventListener("load", resolve, {once: true});
        script.addEventListener("error", reject, {once: true});
        document.head.append(script);
    });

    return adsenseLoadPromise;
}

function adsensePush()
{
    window.adsbygoogle = window.adsbygoogle || [];
    window.adsbygoogle.push({});
}

function adsenseCreateDefaultSlot(ad)
{
    ad.innerHTML = "<ins class='adsbygoogle'"
            + " style='display:block'"
            + " data-ad-client='" + ADSENSE_CLIENT + "'"
            + " data-ad-slot='4983453271'"
            + " data-ad-format='auto'"
            + " data-full-width-responsive='true'></ins>";
    return ad.getElementsByClassName("adsbygoogle")[0];
}

function adsenseHasAvailableWidth(ad)
{
    const slot = ad.getElementsByClassName("adsbygoogle")[0];
    return ad.getBoundingClientRect().width > 0
            && (slot === undefined || slot.getBoundingClientRect().width > 0);
}

function adsenseWaitForAvailableWidth(ad)
{
    if (ad.dataset.adWaitingForSize === "true" || !("ResizeObserver" in window))
    {
        return;
    }
    ad.dataset.adWaitingForSize = "true";

    const observer = new ResizeObserver(() =>
    {
        if (!ad.isConnected)
        {
            observer.disconnect();
            return;
        }
        if (ad.getBoundingClientRect().width <= 0)
        {
            return;
        }
        observer.disconnect();
        delete ad.dataset.adWaitingForSize;
        adsensePushElement(ad);
    });
    observer.observe(ad);
}

function adsenseWaitForRequestToSettle(slot)
{
    return new Promise((resolve) =>
    {
        if (slot.dataset.adsbygoogleStatus === "done" || slot.dataset.adStatus !== undefined)
        {
            resolve();
            return;
        }

        let settled = false;
        const finish = () =>
        {
            if (settled)
            {
                return;
            }
            settled = true;
            observer.disconnect();
            clearTimeout(timer);
            resolve();
        };
        const observer = new MutationObserver(() =>
        {
            if (slot.dataset.adsbygoogleStatus === "done" || slot.dataset.adStatus !== undefined)
            {
                finish();
            }
        });
        const timer = setTimeout(finish, ADSENSE_REQUEST_SETTLE_TIMEOUT_MS);
        observer.observe(slot, {
            attributes: true,
            attributeFilter: ["data-adsbygoogle-status", "data-ad-status"]
        });
    });
}

function adsenseProcessRequestQueue()
{
    if (adsenseRequestInProgress)
    {
        return;
    }

    const ad = adsenseRequestQueue.shift();
    if (ad === undefined)
    {
        return;
    }

    delete ad.dataset.adQueued;
    if (!ad.isConnected || ad.dataset.adRequested === "true")
    {
        adsenseProcessRequestQueue();
        return;
    }
    if (!adsenseHasAvailableWidth(ad))
    {
        adsenseWaitForAvailableWidth(ad);
        adsenseProcessRequestQueue();
        return;
    }

    const slot = ad.getElementsByClassName("adsbygoogle")[0]
            || adsenseCreateDefaultSlot(ad);
    if (slot.getBoundingClientRect().width <= 0)
    {
        adsenseWaitForAvailableWidth(ad);
        adsenseProcessRequestQueue();
        return;
    }

    adsenseRequestInProgress = true;
    ad.dataset.adRequested = "true";
    adsenseObserver(slot);
    try
    {
        adsensePush();
    } catch (err)
    {
        delete ad.dataset.adRequested;
        adsenseWaitForAvailableWidth(ad);
        adsenseRequestInProgress = false;
        adsenseProcessRequestQueue();
        return;
    }

    adsenseWaitForRequestToSettle(slot).finally(() =>
    {
        adsenseRequestInProgress = false;
        adsenseProcessRequestQueue();
    });
}

function adsensePushElement(ad)
{
    if (ad.dataset.adRequested === "true" || ad.dataset.adQueued === "true")
    {
        return;
    }
    if (!adsenseHasAvailableWidth(ad))
    {
        adsenseWaitForAvailableWidth(ad);
        return;
    }
    const slot = ad.getElementsByClassName("adsbygoogle")[0]
            || adsenseCreateDefaultSlot(ad);
    if (slot.getBoundingClientRect().width <= 0)
    {
        adsenseWaitForAvailableWidth(ad);
        return;
    }
    ad.dataset.adQueued = "true";
    adsenseRequestQueue.push(ad);
    adsenseProcessRequestQueue();
}

function adsensePushContainerAds(container)
{
    if (!container || ADSENSE_ENABLED === false)
    {
        return;
    }
    const ads = Array.from(container.getElementsByClassName("fullAdWrapper"))
            .filter((ad) => !ad.classList.contains("houseAdOnly")
                && !ad.classList.contains("spaceAdOnly"));
    consentRequest("advertising", () =>
    {
        adsenseLoad().then(() => ads.forEach(adsensePushElement)).catch(() => {});
    });
}

function adsensePushDeferredElementWhenNearViewport(ad)
{
    if (ad.dataset.adRequested === "true" || ad.dataset.adDeferred === "true")
    {
        return;
    }
    ad.dataset.adDeferred = "true";

    if (!("IntersectionObserver" in window))
    {
        adsensePushElement(ad);
        return;
    }

    const observer = new IntersectionObserver((entries) =>
    {
        if (!entries.some((entry) => entry.isIntersecting))
        {
            return;
        }
        observer.disconnect();
        adsensePushElement(ad);
    }, {rootMargin: ADSENSE_DEFERRED_ROOT_MARGIN});
    const observationTarget = ad.closest(".pageUtilityFooter") || ad;
    observer.observe(observationTarget);
}

function adsensePushDeferredElements(ads)
{
    if (ads.length === 0)
    {
        return;
    }

    ads.forEach(adsensePushDeferredElementWhenNearViewport);
}

function adsensePushFullAds()
{
    const ads = Array.from(document.getElementsByClassName("fullAdWrapper"));
    const houseOnlyAds = ads.filter((ad) => ad.classList.contains("houseAdOnly"));
    const spaceOnlyAds = ads.filter((ad) => ad.classList.contains("spaceAdOnly"));
    const monetizedAds = ads.filter((ad) => !ad.classList.contains("houseAdOnly")
        && !ad.classList.contains("spaceAdOnly"));
    const adsenseOnlyAds = monetizedAds.filter((ad) => ad.classList.contains("adsenseOnly"));
    houseOnlyAds.forEach((ad) => houseAdRender(ad, houseAdFullFormat()));
    spaceOnlyAds.forEach((ad) => spaceAdRender(ad, houseAdFullFormat()));

    const listingAds = monetizedAds.filter((ad) =>
        ad.classList.contains("adWrapper") && ad.classList.contains("mainItem"));
    let espavilatAd = null;
    if (!espavilatIsVisible() && espavilatCanRenderDefault() && listingAds.length > 0)
    {
        const availablePositions = Math.min(ESPAVILAT_MAXIMUM_CAMPAIGNS, listingAds.length);
        espavilatAd = listingAds[espavilatNextPosition(availablePositions)];
    }
    if (ADSENSE_ENABLED === false)
    {
        adsenseOnlyAds.forEach((ad) => { ad.style.display = "none"; });
        monetizedAds
                .filter((ad) => !ad.classList.contains("adsenseOnly"))
                .forEach((ad) =>
        {
            if (ad === espavilatAd)
            {
                espavilatRender(ad, "S", true);
            } else
            {
                houseAdRender(ad, ad.classList.contains("adWrapper") ? "V" : houseAdFullFormat());
            }
        });
        return;
    }

    if (espavilatAd !== null)
    {
        espavilatRender(espavilatAd, "S", true);
    }

    consentRequest("advertising", () =>
    {
        adsenseLoad().then(() =>
        {
            monetizedAds
                    .filter((ad) => !ad.classList.contains("adsenseOnly")
                        && ad !== espavilatAd)
                    .forEach(adsensePushElement);
            adsensePushDeferredElements(adsenseOnlyAds);
        }).catch(() => {
            adsenseOnlyAds.forEach((ad) => { ad.style.display = "none"; });
        });
    });
}


function adsenseAddAndPush(parent, width = 0, responsiveRow = false)
{
    if (!espavilatIsVisible()
            && espavilatCanRenderDefault()
            && (responsiveRow || espavilatIsCurrentDynamicPosition()))
    {
        if (responsiveRow)
        {
            espavilatAddResponsiveRow(parent);
        } else
        {
            espavilatAdd(parent, width);
        }
        return;
    }

    if (ADSENSE_ENABLED === false)
    {
        houseAdAdd(parent, responsiveRow ? 0 : width);
        return;
    }

    // Reserve the position before consent/loading can defer rendering until
    // after the remaining posters have been appended.
    let placement = parent;
    if (width !== 0 || responsiveRow)
    {
        placement = document.createElement("div");
        placement.setAttribute("class", responsiveRow ? "listingAdWrapper" : "adWrapper mainItem");
        placement.style.width = responsiveRow ? "100%" : width + "px";
        placement.style.textAlign = "center";
        placement.style.display = "none";
        parent.appendChild(placement);
    }
    consentRequest("advertising", () =>
    {
        adsenseLoad().then(() =>
        {
            if (!placement.isConnected) return;
            adsenseRenderAndPush(placement, width, responsiveRow);
        }).catch(() => {});
    });
}

function houseAdAdd(parent, width = 0)
{
    if (width !== 0)
    {
        const wrapper = document.createElement("div");
        wrapper.setAttribute("class", "adWrapper mainItem");
        wrapper.style.width = width + "px";
        wrapper.style.textAlign = "center";
        parent.appendChild(wrapper);
        houseAdRender(wrapper, "V");
    } else
    {
        houseAdRender(parent, houseAdFullFormat());
    }
}

function adsenseRenderAndPush(parent, width = 0, responsiveRow = false)
{
    // "Posters footer" ad
    let template = "<ins class='adsbygoogle'"
            + " style='display:block'"
            + " data-ad-client='" + ADSENSE_CLIENT + "'"
            + " data-ad-slot='4983453271'";

    if (!responsiveRow && (width !== 0) && (browserGetBrowserWidth() > ADSENSE_MAXIMUM_WIDTH))
    {
        template += " data-ad-format='vertical'";
    } else
    {
        template += " data-ad-format='auto'";
    }

    template += " data-full-width-responsive='true'></ins>";

    if (width !== 0 || responsiveRow)
    {
        if (!responsiveRow)
        {
            parent.style.minHeight = "320px";
        }
        parent.style.display = "";
    }
    parent.innerHTML = template;
    adsensePushElement(parent);
}

function adsenseAddResponsiveRowAndPush(parent)
{
    adsenseAddAndPush(parent, 0, true);
}

function asdenseCallback(mutations, observer)
{
    for (let mutation of mutations)
    {
        if (mutation.type === 'attributes')
        {
            if (mutation.attributeName === 'data-ad-status')
            {
                if (mutation.target.dataset.adStatus === 'unfilled')
                {
                    const placement = mutation.target.parentElement;
                    if (placement.classList.contains("listingAdWrapper"))
                    {
                        houseAdRender(placement, houseAdFullFormat());
                    } else
                    {
                        placement.style.display = 'none';
                    }
                }
                observer.disconnect();
            }
        }
    }
}

function adsenseObserver(ad)
{
    let observer = new MutationObserver(asdenseCallback);

    observer.observe(ad, {attributes: true, attributeFilter: ["data-ad-status"]});
}

export {ADSENSE_MAXIMUM_WIDTH, adsenseAddAndPush, adsenseAddResponsiveRowAndPush, adsensePushFullAds, adsensePushContainerAds}
